import React from 'react';
import { Button } from '../ui/button';
import { cn } from '../../lib/utils';

export function EmptyState({ icon, title, description, action, compact, className }) {
  const Icon = icon;
  const isEmerald = action?.variant === 'emerald';
  return (
    <div
      className={cn(
        'rounded-xl border border-dashed border-slate-300 bg-white/60 px-6 text-center',
        compact ? 'py-6' : 'py-10',
        className
      )}
    >
      {Icon && (
        <span className="mx-auto grid h-12 w-12 place-items-center rounded-xl bg-slate-100 text-slate-400">
          <Icon className="h-6 w-6" />
        </span>
      )}
      <p className={cn('text-sm font-semibold text-slate-700', Icon && 'mt-3')}>{title}</p>
      {description && <p className="mt-1 text-xs text-slate-500">{description}</p>}
      {action && (
        <div className="mt-4">
          <Button
            type="button"
            size="sm"
            variant={isEmerald ? 'default' : 'outline'}
            className={isEmerald ? 'bg-emerald-600 text-white shadow-sm hover:bg-emerald-700' : undefined}
            onClick={action.onClick}
          >
            {action.label}
          </Button>
        </div>
      )}
    </div>
  );
}
